import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'new-container',
	templateUrl: './new-container.component.html',
})
export class NewContainerComponent implements OnInit {
	constructor(
		private api: ApiService,
		public auth: AuthService,
		private router: Router,
	) {}

	ordini = [];
	ordiniVisualizzati = [];
	isOrderSelected = false;
	isContainerSelected = false;
	selectedOrder;
	selectedContainer;

	anni = [];

	filtri = {
		anno: new Date().getFullYear(),
		daConfermare: false,
		parola: '',
	};

	mokeContainers = [
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 1,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 2,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 3,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 4,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 5,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 6,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 7,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 8,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
		{
			descrizione: 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
			id: 9,
			altezza: 123,
			lunghezza: 456,
			profondita: 789,
			isSelected: false,
		},
	];

	ngOnInit() {
		for (let i = new Date().getFullYear(); i >= 2021; i--) {
			this.anni.push(i);
		}
		this.api.getOrdini().subscribe((res) => {
			this.ordini = res.sort((a, b) => b.dataRegistrazioneOrdine - a.dataRegistrazioneOrdine).filter((o) => o.prodottiCarrello.length > 0);
			this.ordiniVisualizzati = this.ordini;
			this.filtra();
		});
	}

	filtra() {
		this.ordiniVisualizzati = this.ordini;
		if (this.filtri.daConfermare) {
			this.ordiniVisualizzati = this.ordiniVisualizzati.filter((o) => !o.confermato);
		}

		if (this.filtri.anno) {
			this.ordiniVisualizzati = this.ordiniVisualizzati.filter(
				(o) => new Date(o.dataRegistrazioneOrdine).getFullYear() === this.filtri.anno / 1,
			);
		}

		if (this.filtri.parola && this.filtri.parola.length > 0) {
			this.filtri.parola = this.filtri.parola.trim();

			this.ordiniVisualizzati = this.ordiniVisualizzati.filter((o) => {
				return (
					o.id.toString().includes(this.filtri.parola) ||
					o.prodottiCarrello.find((pc) => (pc.nOrdineSimag != null ? pc.nOrdineSimag.includes(this.filtri.parola) : false)) ||
					(o.rifOrdineCliente != null ? o.rifOrdineCliente.includes(this.filtri.parola) : false) ||
					o.quantita.toString().includes(this.filtri.parola) ||
					(this.auth.isAdminOrBackoffice ? o.utente.username.includes(this.filtri.parola) : false)
				);
			});
		}
	}

	trovaNSimag(ordine) {
		const item = ordine.prodottiCarrello.find(({ nOrdineSimag }) => nOrdineSimag && nOrdineSimag !== '0' && nOrdineSimag.trim() !== '');
		return item ? item.nOrdineSimag : 'N/D';
	}

	totaleOrdine(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			totale += item.quantita * item.prodottoCommerciale.listini[0].prezzoNetto;
		});
		return totale;
	}

	onSelectedItem(item, type: string) {
		if (type === 'order') {
			this.ordiniVisualizzati.map((order) => {
				order.isSelected = order.id === item.id ? !order.isSelected : false;
			});
			this.selectedOrder = item;
			this.isOrderSelected = this.ordiniVisualizzati.some((item) => item.isSelected);
		} else {
			this.mokeContainers.map((container) => {
				container.isSelected = container.id === item.id ? !container.isSelected : false;
			});
			this.selectedContainer = item;
			this.isContainerSelected = this.mokeContainers.some((item) => item.isSelected);
		}
	}

	continue() {
		// TODO chiamare api creazione container
		this.router.navigate([`/edit-container/1`]);
	}
}
